import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ResourceStore } from 'src/app/stores/resources/resource.store';
import { FormBuilder, FormGroup, AbstractControl, Validators } from '@angular/forms';
import { TABS } from 'src/app/dummy/tab';
import { MatDialog, MatSnackBar } from '@angular/material';
import { ActivityStore } from 'src/app/stores/resources/activity.store';
import { Location } from '@angular/common';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { ConvertService, removeObjArray } from 'src/app/services/convert.service';
import { STATUS_OBJECT, DISPLAY_STATUS_OBJECT, SKILL_OBJECT } from 'src/app/dummy/status';
import { IActivity } from 'src/app/interfaces/resource';
import { DataService } from 'src/app/services/data.service';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { AddMatchingExerciseComponent } from '../add-matching-exercise/add-matching-exercise.component';
import { Observable } from 'rxjs';
import { FireStorageService } from 'src/app/services/fire-storage.service';

@Component({
  selector: 'app-matching-exercise-listening',
  templateUrl: './matching-exercise-listening.component.html',
  styleUrls: ['./matching-exercise-listening.component.scss']
})
export class MatchingExerciseListeningComponent implements OnInit {
  tabs = TABS.MATCHING_EXERCISE;
  TITLE = "Modules"
  ITEM: any;
  ITEM_KEY: any;
  MODULE_KEY: any;
  MODULE: any;
  form: FormGroup;
  name: FormGroup;
  reading: AbstractControl;
  instruction: AbstractControl;
  defaultInstruction: AbstractControl;

  START_UPLOAD: boolean = false;
  uploadPercentSound: Observable<number>;
  SELECTED_SOUND_FILE: any;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  SKILL = 'listening';
  SKILL_NAME = 'Listening';
  ACTIVITY_TYPE = 'matching_exercise'
  ACTIVITY_LIST: any[] = [];
  ACTIVITY_TYPE_LIST: any[];
  ACTIVITY_TYPE_OBJECT: any = {};

  constructor(private router: Router
    , private route: ActivatedRoute
    , public resource: ResourceStore
    , private fb: FormBuilder
    , private dialog: MatDialog
    , public store: ActivityStore
    , private location: Location
    , private auth: AuthStore
    , private ds: DataService
    , private snackBar: MatSnackBar
    , private storage: FireStorageService
  ) { }

  goBack() {
    this.router.navigate([`/modules/submitted/${this.MODULE.lessonKey}/lesson`])
  }

  // goBackToActivityType() {
  //   this.router.navigate([`/modules/submitted/${this.MODULE.lessonKey}/lesson`])
  // }

  // newActivity() {
  //   this.router.navigate([`/modules/activity-type/${this.ACTIVITY_TYPE}/${this.SKILL}/${this.MODULE_KEY}/draft`])
  // }

  uploadFileSound(event) {
    if(event && event.target.files.length>0){
      this.SELECTED_SOUND_FILE = event;
    }
  }

  // onActivity(activity) {
  //   this.router.navigate([`/modules/activity-type/${activity.activityTypeKey}/${activity.skillKey}/${activity.moduleKey}/${activity.key}`])
  // }

  async ngOnInit() {
    this.form = this.fb.group({
      reading: [null, Validators.required],
      name: [null, Validators.required],
      instruction: [null],
      defaultInstruction: [true],
    })
    this.auth.fetchUser();
    this.route.params.subscribe(async params => {
      const { id, MODULE_KEY } = params;
      this.ITEM_KEY = id;
      this.MODULE_KEY = MODULE_KEY
      this.tabs = TABS.MATCHING_EXERCISE.filter(m=>m.key===this.SKILL).map(m => ({ path: `${m.path}/${MODULE_KEY}/${m.key === SKILL_OBJECT.LISTENING.key ? id : 'draft'}`, label: m.label, key: m.key }))

      this.ACTIVITY_TYPE_LIST = await this.store.fetchActivityType()
      this.ACTIVITY_TYPE_OBJECT = this.ACTIVITY_TYPE_LIST.filter(m => m.key === this.ACTIVITY_TYPE)[0];
      this.MODULE = await this.store.fetchModule(this.MODULE_KEY)
      if (!this.MODULE) {
        this.router.navigate(['/404']);
        return;
      }
      // this.resource.fetchActivityByModule(this.MODULE_KEY, this.ACTIVITY_TYPE, selectedCompanyKey, docs => {
      //   this.ACTIVITY_LIST = docs;
      // })
      if (id !== 'draft') {
        this.store.fetchActivity(id, doc => {
          this.ITEM = doc;
          if (!doc) {
            this.goBack()
            return;
          }
          const { name, instruction, defaultInstruction, reading } = doc;
          this.form.patchValue({ reading, name, instruction, defaultInstruction })
        })
      }
      else {
        this.ITEM = null;
        this.ITEM_KEY = null;
        this.form.patchValue({ reading: null, instruction: null, defaultInstruction: true, name: null })
      }
    })
  }

  ngOnDestroy(): void {
    const { fetchActivityRef } = this.store;
    fetchActivityRef && fetchActivityRef.unsubscribe();
  }

  async onSave(f: any, isBack: boolean) {
    if (!this.SELECTED_SOUND_FILE && !this.ITEM) {
      alert('Please select audio file');
      return;
    }
    if (this.form.valid) {
      this.processClose = isBack ? true : false;
      this.processNew = !isBack;
      this.form.disable();
      const { reading, instruction, defaultInstruction, name } = f;
      const { user, selectedCompanyKey } = this.auth;
      const registerStatus = STATUS_OBJECT.submitted;
      const key = this.ITEM ? this.ITEM.key : this.ds.createId();
      if (this.SELECTED_SOUND_FILE) {
        this.START_UPLOAD = true;
        const picturePath = `${this.MODULE_KEY}/${this.ACTIVITY_TYPE}/${key}`;
        const pictureTask = this.storage.uploadFile(this.SELECTED_SOUND_FILE, picturePath);
        this.uploadPercentSound = pictureTask.percentageChanges();
        const downloadURLPicture = (await pictureTask).ref.getDownloadURL();
        downloadURLPicture.then(downloadURL => {
          const activity: IActivity = {
            key: key,
            status: DISPLAY_STATUS_OBJECT.ACTIVE,
            isDelete: false,
            created_at: this.ITEM ? this.ITEM.created_at : new Date(),
            created_by: this.ITEM ? this.ITEM.created_by : user.uid,
            updated_at: new Date(),
            updated_by: user.uid,
            date_key: this.ITEM ? this.ITEM.date_key : ConvertService.dateKey(),
            page_key: ConvertService.pageKey(),
            keyword: null,
            organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
            organizationKey: selectedCompanyKey,
            created_byRef: this.ITEM ? this.ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
            updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
            register_status: registerStatus,
            //fields
            name: name || null,
            reading: reading || null,
            instruction: instruction || null,
            defaultInstruction: defaultInstruction || false,
            exercises: this.ITEM ? this.ITEM.exercises : [],
            soundDownloadURL: downloadURL,
            hasSubActivity: false,
            //module
            skillKey: this.ITEM ? this.ITEM.skillKey : this.SKILL,
            skillRef: this.ds.skillRef().doc(this.SKILL).ref,
            skillName: this.SKILL_NAME,
            activityTypeKey: this.ACTIVITY_TYPE,
            activityTypeRef: this.ds.activityTypeRef().doc(this.ACTIVITY_TYPE).ref,
            activityTypeName: this.ACTIVITY_TYPE_OBJECT.name,
            moduleKey: this.MODULE_KEY,
            moduleRef: this.ds.firestoreRef().collection(COLLECTION_NAME.MODULE).doc(this.MODULE_KEY).ref,
          }
          this.store.addItem(activity, this.MODULE, this.ITEM ? true : false, (success, res) => {
            if (success) {
              this.snackBar.open("Activity has been saved successful.", "Done", { duration: 1000 });
              this.processClose = false;
              this.processNew = false;
              if (isBack) {
                this.location.back()
              }
              else {
                this.router.navigate([`/modules/activity-type/${this.ACTIVITY_TYPE}/${this.SKILL}/${this.MODULE_KEY}/${activity.key}`])
              }
              this.form.enable();
              this.START_UPLOAD = false;
            }
          })
        })
      }
      else {
        const activity: IActivity = {
          key: key,
          status: DISPLAY_STATUS_OBJECT.ACTIVE,
          isDelete: false,
          created_at: this.ITEM ? this.ITEM.created_at : new Date(),
          created_by: this.ITEM ? this.ITEM.created_by : user.uid,
          updated_at: new Date(),
          updated_by: user.uid,
          date_key: this.ITEM ? this.ITEM.date_key : ConvertService.dateKey(),
          page_key: ConvertService.pageKey(),
          keyword: null,
          organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
          organizationKey: selectedCompanyKey,
          created_byRef: this.ITEM ? this.ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
          updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
          register_status: registerStatus,
          //fields
          name: name || null,
          reading: reading || null,
          instruction: instruction || null,
          defaultInstruction: defaultInstruction || false,
          exercises: this.ITEM ? this.ITEM.exercises : [],
          soundDownloadURL: this.ITEM ? this.ITEM.soundDownloadURL || null : null,
          hasSubActivity: false,
          //module
          skillKey: this.ITEM ? this.ITEM.skillKey : this.SKILL,
          skillRef: this.ds.skillRef().doc(this.SKILL).ref,
          skillName: this.SKILL_NAME,
          activityTypeKey: this.ACTIVITY_TYPE,
          activityTypeRef: this.ds.activityTypeRef().doc(this.ACTIVITY_TYPE).ref,
          activityTypeName: this.ACTIVITY_TYPE_OBJECT.name,
          moduleKey: this.MODULE_KEY,
          moduleRef: this.ds.firestoreRef().collection(COLLECTION_NAME.MODULE).doc(this.MODULE_KEY).ref,
        }
        this.store.addItem(activity, this.MODULE, this.ITEM ? true : false, (success, res) => {
          if (success) {
            this.snackBar.open("Activity has been saved successful.", "Done", { duration: 1000 });
            this.processClose = false;
            this.processNew = false;
            if (isBack) {
              this.location.back()
            }
            else {
              this.router.navigate([`/modules/activity-type/${this.ACTIVITY_TYPE}/${this.SKILL}/${this.MODULE_KEY}/${activity.key}`])
            }
            this.form.enable();
            this.START_UPLOAD = false;
          }
        })
      }

    }
  }

  delete(question) {
    const dialogRef = this.dialog.open(DeleteComponent, {
      data: { button: 'delete', name: question.name, title: 'Delete Question' },
      panelClass: 'cs-overlay-panel',
      width: '35vw',
      height: '',
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.form.disable();
        const { reading, instruction, defaultInstruction, name } = this.form.value;
        const { user, selectedCompanyKey } = this.auth;
        const { exercises } = this.ITEM;
        const QUESTION_DATA = removeObjArray(exercises, question.key)
        const registerStatus = STATUS_OBJECT.submitted;

        const activity: IActivity = {
          key: this.ITEM.key,
          status: DISPLAY_STATUS_OBJECT.ACTIVE,
          isDelete: false,
          created_at: this.ITEM ? this.ITEM.created_at : new Date(),
          created_by: this.ITEM ? this.ITEM.created_by : user.uid,
          updated_at: new Date(),
          updated_by: user.uid,
          date_key: this.ITEM ? this.ITEM.date_key : ConvertService.dateKey(),
          page_key: ConvertService.pageKey(),
          keyword: null,
          organizationRef: this.ds.companyRef().doc(selectedCompanyKey).ref,
          organizationKey: selectedCompanyKey,
          created_byRef: this.ITEM ? this.ITEM.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
          updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
          register_status: registerStatus,
          //fields
          name: name || null,
          reading: reading || null,
          instruction: instruction || null,
          defaultInstruction: defaultInstruction || false,
          exercises: QUESTION_DATA,
          hasSubActivity: false,
          //module
          skillKey: this.ITEM.skillKey,
          skillRef: this.ITEM.skillRef,
          skillName: this.SKILL_NAME,
          activityTypeKey: this.ITEM.activityTypeKey,
          activityTypeRef: this.ITEM.activityTypeRef,
          activityTypeName: this.ACTIVITY_TYPE_OBJECT.name,
          moduleKey: this.ITEM.moduleKey,
          moduleRef: this.ITEM.moduleRef,
        }
        this.store.update(activity, (success, res) => {
          this.snackBar.open("Exercise has been deleted successful.", "Done", { duration: 1000 });
          this.form.enable();
        })
      }
    })
  }


  addNewLine(question) {
    if (!this.ITEM) return;
    let dialogRef = this.dialog.open(AddMatchingExerciseComponent, {
      data: {
        FORM: this.form.value,
        ITEM: this.ITEM,
        SKILL: this.SKILL,
        ACTIVITY_TYPE: this.ACTIVITY_TYPE,
        MODULE_KEY: this.MODULE_KEY,
        QUESTION: question || null,
        ACTIVITY_TYPE_OBJECT: this.ACTIVITY_TYPE_OBJECT,
        SKILL_NAME: this.SKILL_NAME,
        MODULE: this.MODULE,
      },
      panelClass: 'item-list-panel',
      width: '',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

}
